var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckMarkOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 12C9.31371 12 12 9.31371 12 6C12 2.68629 9.31371 0 6 0C2.68629 0 0 2.68629 0 6C0 9.31371 2.68629 12 6 12ZM7.9416 3.91404C8.16848 3.67328 8.589 3.71853 8.82225 3.91404C9.08275 4.13238 9.03453 4.49289 8.82225 4.71814L5.65014 8.08426C5.44641 8.30045 4.97219 8.30998 4.76948 8.08426L3.17562 6.30949C2.95436 6.06311 2.92891 5.75078 3.17562 5.50538C3.38782 5.29432 3.84886 5.27441 4.05628 5.50538L5.22041 6.80165L7.9416 3.91404Z",
    fill: "#3AA03A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckMarkOutline);
export default __webpack_public_path__ + "static/media/checkMarkOutline.06e6075d75bb13fac5b9463cad84b42c.svg";
export { ForwardRef as ReactComponent };